import { render, staticRenderFns } from "./createSolution.vue?vue&type=template&id=685f8462&"
import script from "./createSolution.vue?vue&type=script&lang=ts&"
export * from "./createSolution.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports